import * as React from "react";

import { CircularProgress, Grid, Typography } from "@material-ui/core";
import Breadcrumb from "../components/breadcrumb";
import CategoryHeader from "../components/categoriesHeader";
import SortHeader from "../components/sortsHeader";
import ProductSearch from "../components/productSearch";
import { fixToPersianNumbers, numberWithCommas } from "../../../utils/helpers";
import classes from './index.module.scss';
import CustomePagination from "../components/pagination";
import { Link } from "react-router-dom";
// import { getCategories, getImage, getVitrinProduct, getVitrinProductCount } from "../../apis/apis";
import useQuery from "../../../utils/hook/useQuery";
import ProductRepository from "client-sdk/src/Repository/product-repository";
import handleError from "../../../utils/handleError";
import Headers from "../components/header";

type image = { [key: number]: string }


const Products = (props: any) => {
  const [categories, setCategories] = React.useState([])
  const [products, setProducts] = React.useState([])
  const [count, setCount] = React.useState(0)
  const { filtersValues, setFiltersValues } = useQuery({ page: 0, size: 20 }, "created,desc")
  const [images, setImages] = React.useState({} as image);
  const [activeCategory, setActiveCategory] = React.useState(null)
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    getCategory()
  }, [])

  React.useEffect(() => {
    getProducts()
  }, [filtersValues])

  React.useEffect(() => {
    const catId = filtersValues['categoryId.equals']
    if (catId && categories.length > 0) {
      const category = categories.filter(el => el.id == catId)
      setActiveCategory(category[0])
    }
  }, [filtersValues, categories])

  React.useEffect(() => {
    if (products.length > 0) {
      getImages()
    }
  }, [products])


  const getCategory = async () => {
    const category = await ProductRepository.getVitrinCategories({});
    setCategories(category?.data)
  }

  const getProducts = async () => {
    setLoading(true)
    const products = await ProductRepository.getVitrinProduct({ payload: filtersValues });
    const productsCount = await ProductRepository.getVitrinProductCount({ payload: filtersValues });
    setProducts(products?.data)
    setCount(productsCount?.data)
    setLoading(false)
  }

  const getImages = async () => {
    products.forEach(async (prod: any) => {
      if (prod.imageName) {
        try {
          const image = await ProductRepository.getImagefromVitrin({ payload: { id: prod.id, fileName: prod.imageName } });
          setImages((prev: any) => {
            return {
              ...prev,
              [prod.id]: `data:${image?.headers['content-type']};base64,${image?.data}`
            }
          })
        } catch (err) {
          handleError(err)
        }
      }
    });
  }

  const onPageChange = (event: React.ChangeEvent<unknown>, page: number) => {
    setFiltersValues({ ...filtersValues, page: page - 1 })
  }

  const onChangeSort = (sort: string) => {
    setFiltersValues({ ...filtersValues, sort: sort })
  }

  const changeCategory = (cat: string) => {
    // if(!cat) {
    //   const filters = {...filtersValues}
    //   delete filters["categoryId.equals"];
    //   setFiltersValues(filters)
    //   return
    // }
    setFiltersValues({ ...filtersValues, "categoryId.equals": cat })
  }

  const searchPrice = (query: any) => {
    const qr = { ...query }
    if (!query['price.greaterThanOrEqual']) {
      qr['price.greaterThanOrEqual'] = " "
    }
    if (!query['price.lessThanOrEqual']) {
      qr['price.lessThanOrEqual'] = " "
    }
    setFiltersValues({ ...filtersValues, ...qr });
  }

  const removeFilters = (filter: string) => {
    setFiltersValues({ ...filtersValues })
    // setFiltersValues(filters)
  }
  return (
    <>
      <Headers />
      <div className="container bg-white pb-5">
        <CategoryHeader categories={categories} changeCategory={changeCategory} />
        {/* <Breadcrumb/> */}
        <Grid container className="products-container">
          <Grid lg={2}>
            <ProductSearch cat={activeCategory} onSearch={searchPrice} removeFilters={removeFilters} />
          </Grid>
          <Grid lg={10}>
            <SortHeader onChangeSort={onChangeSort} active={filtersValues["sort"]} count={count} />
            {loading ? <CircularProgress
              color="inherit"
              size={20}
            /> : <Grid container spacing={2} className="mt-2">
              {products.map((el: any, i) => (
                <Grid item lg={3}>
                  <div>
                    {images[el.id] ? (
                      <img src={`${images[el.id]}`} alt="product" className={classes.imgBox} />) :
                      (<img src="/vitrin/images/nophoto.jpg" alt="product" className={classes.imgBox} />)}
                  </div>
                  <Link to={`/vitrin/products/${el.id}`} className="link">
                    <Typography noWrap className={classes.description}>
                      {el.name}
                    </Typography>
                  </Link>
                  <p><span className='text-muted text-sm'>موجودی: </span><span>{
                    el.inventoryDTO === null || el.inventoryDTO.orderAble === null ? 0 : fixToPersianNumbers(`${el?.inventoryDTO?.orderAble}`)
                  }
                    {' '}عدد</span></p>
                  <p className='mt-2'><span className={classes.price}>{fixToPersianNumbers(numberWithCommas(el.price))} </span><span className='text-muted'>تومان</span></p>
                </Grid>
              ))}
              <CustomePagination count={Math.ceil(count / 20)} onPageChange={onPageChange} />
            </Grid>}
          </Grid>
        </Grid>
      </div>
    </>
  )
}

export default Products;